export default __webpack_public_path__ + "static/media/search_icn.5ae3eed0.svg";